import { type Modification } from '../../types';
import { checkIfDressingIngredient } from './check-if-dressing-ingredient';

// ─────────────────────────────────────────────────────────────────────────────

export function getActiveDressingsPortionsNumbers(
  modifications: Modification[],
) {
  return modifications.reduce<number>((total, modification) => {
    const isDressingIngredient = checkIfDressingIngredient(modification);

    if (!isDressingIngredient) return total;

    return total + modification.quantity;
  }, 0);
}
